<template>
  <v-card-actions
    v-if="show"
    class="pagination-container"
  >
    <div class="pagination-content">
      <div class="pagination-info">
        {{ text }}
      </div>
      <div class="pagination-controls">
        <v-btn
          icon
          x-small
          :disabled="!canPrev"
          class="pagination-button"
          @click="$emit('prev')"
        >
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          icon
          x-small
          :disabled="!canNext"
          class="pagination-button"
          @click="$emit('next')"
        >
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
  </v-card-actions>
</template>

<script>
export default {
  name: 'PaginationControls',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    canPrev: {
      type: Boolean,
      default: false
    },
    canNext: {
      type: Boolean,
      default: false
    }
  }
};
</script>

